export default "/images/chevron-double-right.svg?cd935c125fcba8fdcab900756346df17";